import request from '@/libs/request';

// 名单管理接口

// 新增名单
export const AddRoster = (data) => request('AddRoster', data);
// 修改名单
export const UpdateRoster = (data) => request('UpdateRoster', data);
// 删除名单
export const DelRoster = (data) => request('DelRoster', data);
// 查看名单列表
export const GetRosterList = (data) => request('GetRosterList', data);
// 查看名单详情
export const GetRosterInfo = (data) => request('GetRosterInfo', data);

// 下载导入模板
export const GetRosterTemplate = (data) => request('GetRosterTemplate', data);
// 导入名单数据
export const ImportRosterData = (data) => request('ImportRosterData', data);
// 查看导入记录列表
export const GetRosterRecordList = (data) => request('GetRosterRecordList', data);
// 查看导入记录详情
export const GetRosterRecordInfo = (data) => request('GetRosterRecordInfo', data);

// 查看可发送数量
export const GetSendUserNum = (data) => request('GetSendUserNum', data);
// 查看可发送列表
export const GetSendUserList = (data) => request('GetSendUserList', data);

// 粉丝名单
// 查看可发送粉丝数量
export const GetSendFansNum = (data) => request('GetSendFansNum', data);
// 查看可发送粉丝列表
export const GetSendFansList = (data) => request('GetSendFansList', data);
